import * as yaNative from '@yanolja-rnd/ya-native';
import { UAParser } from 'ua-parser-js';
import { Kinesis } from '@aws-sdk/client-kinesis';
import { Buffer } from 'buffer';
import Cookies from 'js-cookie';
import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers';
import ReactGA4 from 'react-ga4';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

var isMergeableObject = function isMergeableObject(value) {
  return isNonNullObject(value) && !isSpecial(value);
};
function isNonNullObject(value) {
  return !!value && _typeof(value) === 'object';
}
function isSpecial(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol["for"];
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol["for"]('react.element') : 0xeac7;
function isReactElement(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}
function defaultArrayMerge(target, source, options) {
  return target.concat(source).map(function (element) {
    return cloneUnlessOtherwiseSpecified(element, options);
  });
}
function getMergeFunction(key, options) {
  if (!options.customMerge) {
    return deepmerge;
  }
  var customMerge = options.customMerge(key);
  return typeof customMerge === 'function' ? customMerge : deepmerge;
}
function getEnumerableOwnPropertySymbols(target) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function (symbol) {
    return Object.propertyIsEnumerable.call(target, symbol);
  }) : [];
}
function getKeys(target) {
  return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
}
function propertyIsOnObject(object, property) {
  try {
    return property in object;
  } catch (_) {
    return false;
  }
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
  return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
  && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
  && Object.propertyIsEnumerable.call(target, key)); // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
  var destination = {};
  if (options.isMergeableObject(target)) {
    getKeys(target).forEach(function (key) {
      destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
  }
  getKeys(source).forEach(function (key) {
    if (propertyIsUnsafe(target, key)) {
      return;
    }
    if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
      destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
    } else {
      destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
    }
  });
  return destination;
}
function deepmerge(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge;
  options.isMergeableObject = options.isMergeableObject || isMergeableObject;
  // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
  // implementations can use it. The caller may not replace it.
  options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject(target, source, options);
  }
}
deepmerge.all = function deepmergeAll(array, options) {
  if (!Array.isArray(array)) {
    throw new Error('first argument should be an array');
  }
  return array.reduce(function (prev, next) {
    return deepmerge(prev, next, options);
  }, {});
};
var deepmerge_1 = deepmerge;
var cjs = deepmerge_1;

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}
function unsafeStringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  //
  // Note to future-self: No, you can't remove the `toLowerCase()` call.
  // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).

var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }
  return getRandomValues(rnds8);
}

var randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var _native = {
  randomUUID: randomUUID
};

function v4(options, buf, offset) {
  if (_native.randomUUID && !buf && !options) {
    return _native.randomUUID();
  }
  options = options || {};
  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    offset = offset || 0;
    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }
    return buf;
  }
  return unsafeStringify(rnds);
}

var region$1 = 'ap-northeast-2';
/**
 * 인증 정보 객체.
 * 재사용 하지 않으면 인증 가능 유저 수 초과로 오류가 발생한다.
 * @link {https://jira.yanolja.in/browse/INCIDENT-569}
 */
var _credentials;
/**
 * Kinesis 클라이언트 로그 전송에 필요한 인증 정보를 획득하기 위해 사용되는 함수
 * @param IdentityPoolId {string} 인증 정보 identitypool
 * @param region {string} 인증 정보 region
 * @param forceUpdate {boolean} provide 강제 갱신 여부
 * @param credentials {CognitoIdentityCredentials}
 */
function getCredentials(_a) {
    var IdentityPoolId = _a.IdentityPoolId, _b = _a.forceUpdate, forceUpdate = _b === void 0 ? false : _b, _c = _a.credentials, credentials = _c === void 0 ? _credentials : _c;
    return __awaiter(this, void 0, void 0, function () {
        var credentialsProvider, e_1;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 3, , 4]);
                    if (!(!credentials || isExpiredCredentials(credentials) || forceUpdate)) return [3 /*break*/, 2];
                    credentialsProvider = fromCognitoIdentityPool({
                        identityPoolId: IdentityPoolId,
                        clientConfig: { region: region$1 },
                        userIdentifier: forceUpdate ? v4() : undefined, // cgntId 중복 발급 방지
                    });
                    return [4 /*yield*/, credentialsProvider()];
                case 1:
                    _credentials = _d.sent();
                    _d.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    e_1 = _d.sent();
                    console.error(e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, _credentials];
            }
        });
    });
}
/**
 * 파라미터로 입력받은 인증 정보가 만료되었는지 여부를 반환하는 함수
 * @param credentials
 */
function isExpiredCredentials(credentials) {
    var _a;
    var expired = (_a = credentials === null || credentials === void 0 ? void 0 : credentials.expiration) !== null && _a !== void 0 ? _a : 0;
    return expired < Date.now();
}

var apiVersion = '2013-12-02';
var region = 'ap-northeast-2';
/**
 * 야놀자 웹에서 사용되는 Kinesis 클라이언트 로그 전송 인스턴스
 * AWS Kinesis 객체를 이용하여 전송한다.
 * @link {https://confluence.yanolja.in/pages/viewpage.action?pageId=454704659}
 */
var _KinesisInstanceWrapper = /** @class */ (function () {
    /**
     *
     * @param IdentityPoolId {string} 인증 정보를 생성하기 위한 pool id
     * @param cred {CognitoIdentityCredentials} cognito 인증 정보
     * @param streamName {string} 로깅 위치 정보
     * @param onError {(any, commandOutput) => void} 예외 발생 핸들러. Sentry 로깅 추천
     * @private
     */
    function _KinesisInstanceWrapper(IdentityPoolId, cred, streamName, onError) {
        // 기본값 처리
        this.IdentityPoolId = IdentityPoolId;
        this.streamName = streamName;
        this.onError = onError;
        this.cred = cred;
        // kinesis 객체 생성
        this.instance = new Kinesis({
            credentials: cred,
            apiVersion: apiVersion,
            region: region,
        });
        var cgntId = Cookies.get('cgntId');
        if (!cgntId) {
            // 쿠키에 cgntId 없는 경우 받아온 cgntId로 쿠키 재설정
            cgntId = cred.identityId;
        }
        this.cgntId = cgntId;
        Cookies.set('cgntId', cgntId, { domain: '.yanolja.com', expires: 1825 });
    }
    /**
     * kinesisInstanceWrapper 객체를 획득하는 static 메소드
     * @param IdentityPoolId {string} 인증 정보를 획득할 cognito Identity pool id
     * @param streamName {string} 로그 구분에 사용되는 stream id
     * @param onError {Function} 예외처리 함수
     */
    _KinesisInstanceWrapper.getInstance = function (IdentityPoolId, streamName, onError) {
        return __awaiter(this, void 0, void 0, function () {
            var cred;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof window === 'undefined')
                            return [2 /*return*/];
                        return [4 /*yield*/, getCredentials({ IdentityPoolId: IdentityPoolId })];
                    case 1:
                        cred = _a.sent();
                        if (cred) {
                            return [2 /*return*/, new _KinesisInstanceWrapper(IdentityPoolId, cred, streamName, onError)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 인증 정보가 만료되었는지 확인하고 갱신하는 메소드
     */
    _KinesisInstanceWrapper.prototype.updateCognitoIdentityCredentials = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cred;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.cred || !this.cred.expiration)
                            return [2 /*return*/];
                        if (!(this.cred.expiration < new Date())) return [3 /*break*/, 2];
                        return [4 /*yield*/, getCredentials({ IdentityPoolId: this.IdentityPoolId })];
                    case 1:
                        cred = _a.sent();
                        if (cred) {
                            this.cred = cred;
                            this.instance = new Kinesis({
                                credentials: cred,
                                apiVersion: apiVersion,
                                region: region,
                            });
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Kinesis 서버로 로그 정보를 전송하는 메소드
     * 전송중 페이지 이동을 해버리면 'Load Failed' 에러가 발생한다
     * @link {https://yanolja-rnd.sentry.io/issues/4038733894/events/52d02dda11594f14a94ff159347afeaa/?project=5509180}
     * @param data
     */
    _KinesisInstanceWrapper.prototype.sendData = function (data) {
        var _this = this;
        return new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
            var kinesisLogData, record;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof window === 'undefined' || !data)
                            return [2 /*return*/, resolve()];
                        // 인증 정보가 만료된 경우 갱신
                        return [4 /*yield*/, this.updateCognitoIdentityCredentials()];
                    case 1:
                        // 인증 정보가 만료된 경우 갱신
                        _a.sent();
                        kinesisLogData = Object.assign(data, { cgntId: this.cgntId });
                        record = {
                            Data: Buffer.from(JSON.stringify(kinesisLogData)),
                            PartitionKey: this.cgntId,
                        };
                        // 로그 전송 타임아웃.
                        setTimeout(function () { return resolve(); }, 300);
                        // 로그전송
                        this.instance.putRecords({
                            Records: [record],
                            StreamName: this.streamName,
                        }, function (err, errorData) {
                            var _a;
                            if (err) {
                                (_a = _this.onError) === null || _a === void 0 ? void 0 : _a.call(_this, { err: err, data: errorData, kinesisLogData: kinesisLogData });
                            }
                            resolve();
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * cognito id 획득 메소드
     */
    _KinesisInstanceWrapper.prototype.getCognitoId = function () {
        return this.cgntId;
    };
    return _KinesisInstanceWrapper;
}());

/**
 * 야놀자 앱에서 사용되는 Kinesis 클라이언트 로그 전송 인스턴스
 * Native에서 열린 하이브리드 페이지에서는
 * yaNative 라이브러리를 이용하여 직접 Kinesis 클라이언트 로그를 전송한다.
 */
var _NativeKinesisWrapper = /** @class */ (function () {
    function _NativeKinesisWrapper() {
    }
    _NativeKinesisWrapper.getInstance = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new _NativeKinesisWrapper()];
            });
        });
    };
    /**
     * yaNative 인터페이스를 이용한 로그 전송 메소드
     *
     * @param kinesisLogData {any} 로그 전송할 데이터
     */
    _NativeKinesisWrapper.prototype.sendData = function (kinesisLogData) {
        var _this = this;
        return new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
            var _yaNative;
            return __generator(this, function (_a) {
                _yaNative = typeof window === 'undefined' ? null : yaNative.getYaNative();
                // 로그 전송 타임아웃.
                setTimeout(function () { return resolve(); }, 300);
                if ((_yaNative === null || _yaNative === void 0 ? void 0 : _yaNative.isEnabled) && kinesisLogData) {
                    // Native 에서 열린 Hybrid 페이지에서는 yaNative library 를 사용하여 kinesis 로그전송
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    _yaNative.kinesis(kinesisLogData, function () { return resolve(); });
                }
                return [2 /*return*/];
            });
        }); });
    };
    /**
     * 앱의 cognito id은 추출 불가, 시스템 프로퍼티는 앱에서 직접 전송
     */
    _NativeKinesisWrapper.prototype.getCognitoId = function () {
        return '';
    };
    return _NativeKinesisWrapper;
}());

var _kinesisTracker;
// 초기화 이전 전송 시도한 로그 최대 개수
var MAX_BEFORE_INITIALIZE_TEMPORAL_LOG = 20;
// 초기화 이전 전송 시도한 로그 수집 배열
var _beforeInitializeTemporalLog = [];
// objectWith가 있는 impression 로그는 100개가 모이거나 다른 로그가 전송될 때 한번에 전송한다.
var _impressionLogList = [];
// kinesis 초기화 옵션
var _kinesisInitializedOptions = undefined;
/**
 * Kinesis 클라이언트 로그를 전송하는 객체
 */
var _KinesisTracker = {
    /**
     * Kinesis 전송용 객체 획득
     * @param options {KinesisInitializeOption} 트래커 초기화 옵션
     */
    initialize: function (options) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var IdentityPoolId, streamName, onError, _b, forceWebLog, isEnabled;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (typeof window === 'undefined')
                            return [2 /*return*/];
                        _kinesisInitializedOptions = options;
                        IdentityPoolId = options.IdentityPoolId, streamName = options.streamName, onError = options.onError, _b = options.forceWebLog, forceWebLog = _b === void 0 ? false : _b;
                        // kinesis 트래커 객체는 1회만 생성
                        if (_kinesisTracker)
                            return [2 /*return*/];
                        isEnabled = typeof window === 'undefined' ? false : (_a = yaNative === null || yaNative === void 0 ? void 0 : yaNative.getYaNative()) === null || _a === void 0 ? void 0 : _a.isEnabled;
                        return [4 /*yield*/, (forceWebLog || isEnabled
                                ? _NativeKinesisWrapper.getInstance()
                                : _KinesisInstanceWrapper.getInstance(IdentityPoolId, streamName, onError))];
                    case 1:
                        _kinesisTracker = _c.sent();
                        if (!(_beforeInitializeTemporalLog === null || _beforeInitializeTemporalLog === void 0 ? void 0 : _beforeInitializeTemporalLog.length)) return [3 /*break*/, 3];
                        return [4 /*yield*/, Promise.all(_beforeInitializeTemporalLog.map(this.sendEvent))];
                    case 2:
                        _c.sent();
                        _beforeInitializeTemporalLog.splice(0);
                        _c.label = 3;
                    case 3:
                        // 페이지를 이탈할 때 전송하지 않았던 impression log가 있다면 전송
                        window.removeEventListener('beforeunload', this.flushImpressionEvent);
                        window.addEventListener('beforeunload', this.flushImpressionEvent);
                        return [2 /*return*/];
                }
            });
        });
    },
    /**
     * 이미 initialize로 설정된 옵션을 업데이트하는 함수.
     * 옵션 자체를 완전히 변경하는 것이 아니라 파라미터로 받은 값만을 업데이트한다.
     * kinesis tracker 자체를 새로 생성하지는 않으므로 재생성이 필요하면 initialize를 호출해야 한다.
     */
    updateOption: function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (typeof window === 'undefined')
                    return [2 /*return*/];
                _kinesisInitializedOptions = cjs.all([
                    {},
                    _kinesisInitializedOptions || {},
                    options,
                ]);
                return [2 /*return*/];
            });
        });
    },
    /**
     * 'impression' 이벤트 타입 클라이언트 로그 전송 메소드
     * @see {YaTrackerImpression}
     * @param pageName {string} 로그를 구분할 페이지명
     * @param data {KinesisTrackingData} 전송할 로그 데이터
     */
    impression: function (pageName, data) {
        var _a;
        if (data === void 0) { data = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var userTrackingData, shouldCollectBatches;
            return __generator(this, function (_b) {
                userTrackingData = __assign({ pageName: pageName, eventType: 'impr' }, data);
                shouldCollectBatches = (_kinesisInitializedOptions === null || _kinesisInitializedOptions === void 0 ? void 0 : _kinesisInitializedOptions.collectImpressionBatches) !== false;
                // objectsWith가 있는 impression 로그는 100개가 모이거나 다른 로그가 전송될 때 함께 전송
                if (shouldCollectBatches && ((_a = data.objectsWith) === null || _a === void 0 ? void 0 : _a.length) && _impressionLogList.length < 100) {
                    _impressionLogList.push(userTrackingData);
                    return [2 /*return*/];
                }
                return [2 /*return*/, this.sendEvent(userTrackingData)];
            });
        });
    },
    /**
     * 'view' 이벤트 타입 클라이언트 로그 전송 메소드
     * @param pageName {string} 로그를 구분할 페이지명
     * @param data {KinesisTrackingData} 전송할 로그 데이터
     */
    view: function (pageName, data) {
        if (data === void 0) { data = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.flushImpressionEvent()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.sendEvent(__assign({ pageName: pageName, eventType: 'view' }, data))];
                }
            });
        });
    },
    /**
     * 'resume' 이벤트 타입 클라이언트 로그 전송 메소드
     * @link {https://yanoljain.slack.com/archives/C8TCHG6LU/p1674022842228639}
     * @param pageName {string} 로그를 구분할 페이지명
     * @param data {KinesisTrackingData} 전송할 로그 데이터
     * @deprecated
     */
    resume: function (pageName, data) {
        if (data === void 0) { data = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.flushImpressionEvent()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.sendEvent(__assign({ pageName: pageName, eventType: 'resume' }, data))];
                }
            });
        });
    },
    /**
     * 'click' 이벤트 타입 클라이언트 로그 전송 메소드
     * @param pageName {string} 로그를 구분할 페이지명
     * @param data {KinesisTrackingData} 전송할 로그 데이터
     */
    click: function (pageName, data) {
        if (data === void 0) { data = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.flushImpressionEvent()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.sendEvent(__assign({ pageName: pageName, eventType: 'click' }, data))];
                }
            });
        });
    },
    /**
     * 'bg' 이벤트 타입 클라이언트 로그 전송 메소드
     * @param pageName {string} 로그를 구분할 페이지명
     * @param data {KinesisTrackingData} 전송할 로그 데이터
     */
    bg: function (pageName, data) {
        if (data === void 0) { data = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.flushImpressionEvent()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.sendEvent(__assign({ pageName: pageName, eventType: 'bg' }, data))];
                }
            });
        });
    },
    /**
     * 지금까지 누적한 impression 로그 flush
     */
    flushImpressionEvent: function () {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _impressionLogList_1, impressionLogData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(_impressionLogList === null || _impressionLogList === void 0 ? void 0 : _impressionLogList.length))
                            return [2 /*return*/];
                        _i = 0, _impressionLogList_1 = _impressionLogList;
                        _a.label = 1;
                    case 1:
                        if (!(_i < _impressionLogList_1.length)) return [3 /*break*/, 4];
                        impressionLogData = _impressionLogList_1[_i];
                        return [4 /*yield*/, _KinesisTracker.sendEvent(impressionLogData)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    /**
     * 로우레벨 통계 전송 메소드. 직접 사용하는 일은 흔치 않을 것으로 보임
     * @param userTrackingData {TTrackingData} 전송할 클라이언트 로그 전체 데이터
     */
    sendEvent: function (userTrackingData) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var max, transformedUserTrackingData, trackingData;
            return __generator(this, function (_b) {
                if (typeof window === 'undefined') {
                    return [2 /*return*/];
                }
                // kinesis 객체가 초기화되지 않았다면 대기
                if (!_kinesisTracker || !_kinesisInitializedOptions) {
                    _beforeInitializeTemporalLog.push(userTrackingData);
                    max = (_kinesisInitializedOptions === null || _kinesisInitializedOptions === void 0 ? void 0 : _kinesisInitializedOptions.temporalLogLimit) || MAX_BEFORE_INITIALIZE_TEMPORAL_LOG;
                    if (_beforeInitializeTemporalLog.length > max) {
                        _beforeInitializeTemporalLog.shift();
                    }
                    return [2 /*return*/];
                }
                transformedUserTrackingData = defaultTransform(((_a = _kinesisInitializedOptions === null || _kinesisInitializedOptions === void 0 ? void 0 : _kinesisInitializedOptions.logTransform) === null || _a === void 0 ? void 0 : _a.call(_kinesisInitializedOptions, userTrackingData)) || userTrackingData);
                trackingData = __assign(__assign(__assign({}, getSystemProperties()), { mid: (_kinesisInitializedOptions === null || _kinesisInitializedOptions === void 0 ? void 0 : _kinesisInitializedOptions.isLoginUser) ? 'm' : undefined, mGrade: _kinesisInitializedOptions === null || _kinesisInitializedOptions === void 0 ? void 0 : _kinesisInitializedOptions.memberGrade, hashedMemberNo: _kinesisInitializedOptions === null || _kinesisInitializedOptions === void 0 ? void 0 : _kinesisInitializedOptions.hashedMemberNo, env: _kinesisInitializedOptions === null || _kinesisInitializedOptions === void 0 ? void 0 : _kinesisInitializedOptions.env, webVersion: (_kinesisInitializedOptions === null || _kinesisInitializedOptions === void 0 ? void 0 : _kinesisInitializedOptions.webVersion) || '1.0.0', cgntId: _kinesisTracker.getCognitoId(), nolMemberProxyId: _kinesisInitializedOptions === null || _kinesisInitializedOptions === void 0 ? void 0 : _kinesisInitializedOptions.nolMemberProxyId }), transformedUserTrackingData);
                // 전송
                return [2 /*return*/, _kinesisTracker === null || _kinesisTracker === void 0 ? void 0 : _kinesisTracker.sendData(trackingData)];
            });
        });
    },
};
/**
 * 클라이언트 로그에 포함되는 시스템 정보 획득 함수
 */
function getSystemProperties() {
    if (typeof window === 'undefined' || yaNative.getYaNative().isEnabled)
        return {};
    var parser = new UAParser(window.navigator.userAgent);
    var webType = getWebType(parser.getDevice());
    return {
        webType: webType,
        currentUri: window.location.href,
        createdTs: Number(new Date()),
        osInfo: getOSInfo(parser.getOS()),
        deviceName: getDeviceInfo(webType, parser.getDevice()),
        browserInfo: getBrowserInfo(parser.getBrowser()),
        userAgent: window.navigator.userAgent,
        referrer: document.referrer,
        resolution: window.innerWidth + "x" + window.innerHeight,
        langCode: window.navigator.language,
        timeZone: getTimezoneOffset(),
    };
}
/**
 * 모바일 웹인지, 웹인지 구분한다.
 * */
var getWebType = function (device) {
    if (device.type === 'mobile' || device.type === 'tablet') {
        return 'mweb';
    }
    return 'web';
};
/**
 * UA에서 운영체제와 버전을 반환한다.
 */
var getOSInfo = function (uaOS) {
    if (!uaOS.name) {
        return 'undefined';
    }
    return (uaOS.name + " " + (uaOS.version || '')).trim();
};
/**
 * UA에서 브라우저명 및 버전을 반환한다.
 */
var getBrowserInfo = function (uaBrowser) {
    if (!uaBrowser.name) {
        return 'undefined';
    }
    return (uaBrowser.name + " " + (uaBrowser.version || '')).trim();
};
/**
 * UA에서 배급자와 모델명을 반환한다.
 *
 * @returns
 * 1. 배급자와 모델 둘 다 알 수 있으면 `'Vendor Model'`
 * 2. 모델만 알면 `'Model'`
 * 2. 배급자는 알지만 모델을 모르면 `'undefined (Vendor)'`
 * 3. 둘 다 모르지만 PC면 `'undefined (Generic PC)'`
 * 4. `'undefined'`
 */
var getDeviceInfo = function (webType, uaDevice) {
    var getDeviceNameString = function () { return ((uaDevice.vendor || '') + " " + uaDevice.model).trim(); };
    if (webType === 'mweb') {
        if (!uaDevice.model) {
            return uaDevice.vendor ? "undefined (" + uaDevice.vendor + ")" : 'undefined';
        }
        return getDeviceNameString();
    }
    if (!uaDevice.model) {
        return uaDevice.vendor ? "undefined (" + uaDevice.vendor + ")" : 'undefined (Generic PC)';
    }
    return getDeviceNameString();
};
/**
 * 클라이언트의 현재 시간 정보 획득 함수
 */
function getTimezoneOffset() {
    var now = new Date();
    var tzOffset = now.getTimezoneOffset();
    var isTzFaster = tzOffset <= 0; // UTC+9 = -540 = 0900 : UTC-9 = 540 = -0900
    var tzHoursRaw = Math.abs(Math.floor(tzOffset / 60));
    var tzHours = tzHoursRaw.toString().padStart(2, '0');
    var tzMinutesRaw = Math.abs(Math.floor(tzOffset % 60));
    var tzMinutes = tzMinutesRaw.toString().padStart(2, '0');
    return "" + (isTzFaster ? '' : '-') + tzHours + ":" + tzMinutes;
}
/**
 * applog - weblog 불일치 해결을 위해 값이 undefined인 필드를 제거
 */
function defaultTransform(_trackingData) {
    var trackingData = __assign({}, _trackingData);
    Object.keys(trackingData).forEach(function (key) {
        if (trackingData.hasOwnProperty(key) && trackingData[key] === undefined) {
            delete trackingData[key];
        }
    });
    return trackingData;
}

/**
 * Braze 클라이언트 로그를 전송하기 위한 객체
 * Braze는 앱에서만 전송된다.
 * @link {https://jira.yanolja.in/browse/YAFE-184}
 */
var _BrazeWrapper = {
    /**
     * 정의된 커스텀 이벤트를 전송하는 메소드
     * @link {https://docs.google.com/spreadsheets/d/1iJdrTz1HPMxbPx7Au9SSv6S6DZas32ZbnFzEy0WtbMk/edit#gid=1308376500}
     * @param eventName
     * @param data
     */
    sendCustomEvent: function (eventName, data) {
        var _yaNative = typeof window === 'undefined' ? null : yaNative.getYaNative();
        if (!(_yaNative === null || _yaNative === void 0 ? void 0 : _yaNative.isEnabled))
            return;
        // 야놀자 앱에서 braze 로그 전송
        _yaNative.braze(__assign({ eventName: eventName }, data), function () { return null; });
    },
};

/**
 * GA4 클라이언트 로그를 전송하는 객체
 */
var _GA4Tracker = {
    /**
     * 웹 GA4 통계 전송을 위해 설치
     * @param gaApiKey {string} ga4 api 키
     */
    initialize: function (_a) {
        var gaApiKey = _a.gaApiKey;
        if (typeof window === 'undefined')
            return;
        // 웹에서만 ReactGa4 설치
        if (!yaNative.getYaNative().isEnabled && gaApiKey) {
            ReactGA4.initialize(gaApiKey);
        }
    },
    /**
     * GA4 커스텀 이벤트 전송
     * @param eventName
     * @param data
     */
    event: function (eventName, data) {
        // GA4 웹/앱 분기처리 전송
        var _yaNative = yaNative.getYaNative();
        if (!_yaNative.isEnabled) {
            ReactGA4.event(eventName, data);
        }
        else {
            _yaNative.ga4f(__assign({ eventName: eventName }, data), function () { return null; });
        }
    },
};

// criteo 기기 구분값.
var deviceType;
var initialized = false;
/**
 * Criteo OneTag 이벤트 전송 객체
 * @see {@link https://docs.google.com/spreadsheets/d/1XJ2-sOkp4IXiojAkX2SXXegTPHUU2iQxXrwRlTeeMa4/edit#gid=871061034}
 * @see {@link https://guides.criteotilt.com/onetag/onetag_ko/?accountid=60428&advertisername=Yanolja+KR&subdomain=&domain=&homepageurl=http%3A%2F%2Fyanolja.com%2F&accuratekey=yanoljakr%3B7832890%3B7832891%3B60428#_5}
 */
var _CriteoTracker = {
    /**
     * Criteo API 초기화 함수
     * criteo는 고객사 id (야놀자:60428)를 이용하여 JS 파일을 로드하므로 API key를 따로 입력받지 않는다.
     */
    initialize: function () {
        // GA4 웹/앱 분기처리 전송
        if (typeof window === 'undefined' || initialized || yaNative.getYaNative().isEnabled)
            return;
        // criteo 스크립트 삽입
        var $script = document.createElement('script');
        $script.async = true;
        $script.src = "//dynamic.criteo.com/js/ld/ld.js?a=60428";
        document.head.append($script);
        // 기본 초기화 구문 처리
        window.criteo_q = window.criteo_q || [];
        deviceType = /iPad/.test(navigator.userAgent)
            ? 't'
            : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent)
                ? 'm'
                : 'd';
        // 이미 스크립트 삽입된 경우 재실행 방지
        initialized = true;
    },
    /**
     * Criteo OneTag 전송 함수.
     * setAccount, setSiteType은 기본값 처리하므로 전송할 필요 없음
     * @param events {CriteoOneTagEvent[]}
     */
    push: function (events) {
        var _a;
        if (typeof window === 'undefined' || yaNative.getYaNative().isEnabled)
            return;
        // 기본 배열 처리
        window.criteo_q = window.criteo_q || [];
        (_a = window.criteo_q).push.apply(_a, __spreadArray(__spreadArray([], events), [
            // 사이트 계정 구분값(야놀자)
            { event: 'setAccount', account: 60428 },
            // 사이트에 접속한 디바이스 타입 구분 값
            { event: 'setSiteType', type: deviceType }]));
    },
};

export { _BrazeWrapper as BrazeTracker, _CriteoTracker as CriteoTracker, _GA4Tracker as GA4Tracker, _KinesisTracker as KinesisTracker, getCredentials };
